import {
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Inject,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CommonService } from '../../services/common.service';
import { ToastrService } from 'ngx-toastr';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { ShareCodeAddTeamsComponent } from '../share-code-add-teams/share-code-add-teams.component';
import { Route, Router } from '@angular/router';
import { ImageTransform } from 'ngx-image-cropper';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { AddPlayerModalComponent } from '../add-player/add-player-modal.component';
import { ClubServicesService } from '../../services/club-services.service';

@Component({
  selector: 'app-addteams-modal',
  templateUrl: './addteams-modal.component.html',
  styleUrls: ['./addteams-modal.component.scss'],
})
export class AddteamsModalComponent implements OnInit {
  // ********************************************************************************************
  // VARIABLE START
  imgURL: any = 'assets/icon/add-team.png';
  fileName: any;
  submitted: boolean = false;
  sharedCodeVal: any = '';
  modalRef: BsModalRef;
  croppedProfilePicRef: any;
  imageChangedEvent: any = '';
  profilePicCropperUrl: any;
  originalProfilePicRef: any;
  originalProfilePicName: any;
  imageTransform: ImageTransform = {};
  checkImage: any;
  playersList: any = [];
  @ViewChild('ProfilePicCropModal') ProfilePicCropModal: TemplateRef<any>;
  defaultImage = '../../../../assets/icons/Loading_icon.gif';

  // VARIABLE END
  // ********************************************************************************************

  // ********************************************************************************************
  // Default FN START
  constructor(
    private csObj: CommonService,
    private toast: ToastrService,
    private fb: FormBuilder,
    private dialogue: MatDialog,
    private router: Router,
    private modalService: BsModalService,
    private spinner: SpinnerVisibilityService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private clubService: ClubServicesService
  ) {
    console.log('data', this.data);
  }
  teamName = this.data.userType.teamName;
  teamSize = this.data?.userType?.team?.teamSize || null;
  addTeamForm = this.fb.group({
    addteamName: new FormControl(this.teamName, [
      Validators.required,
    ]),
    // add team size number and optional and initial value is null
    addteamSize: new FormControl(this.teamSize, []),
  });

  ngOnInit(): void {
    this.playersList = this.data?.userType?.team;
    console.log(this.playersList, 'this.playersList');
    if (this.data.userType.access == 'edit') {
      console.log(this.data.userType.teamName, 'teamName');
      // this.imgURL = this.data.userType.imgPath;
      this.imgURL = this.data.userType.imgPath
        ? this.data.userType.imgPath
        : 'assets/icon/add-team.png';
      // this.addTeamForm.value.addteamName = this.data.userType.teamName
    }
  }

  get f() {
    return this.addTeamForm.controls;
  }
  // Default FN END
  // ********************************************************************************************

  // ********************************************************************************************
  // onChangeimg START
  onChangeimg(e: any) {
    console.log('onChangeimg ', e.loaded, e.total);
    let files = e.target.files;
    let file = e.target.files[0];
    let fd = new FormData();
    fd.append('image', file);
    if (e.target.files && e.target.files.length) {
      for (const file of e.target.files) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        // reader.onload = () => {
        //   const img = new Image();
        //   img.src = reader.result as string;
        //   img.onload = () => {
        //     const height = img.naturalHeight;
        //     const width = img.naturalWidth;
        //     console.log("Width and Height", width, height);
        // if (width <= 534 && height <= 490) {
        // this.size = true;
        this.csObj.uploadImage(fd).subscribe(
          (res: any) => {
            // this.uploaded = true;
            if (files.length === 0) return;

            var mimeType = files[0].type;
            if (mimeType.match(/image\/*/) == null) {
              this.toast.error('Only images are supported.');
              return;
            }

            this.fileName = res.output.imageUrl1.location;
            var reader = new FileReader();
            // this.imagePath = files;
            reader.readAsDataURL(files[0]);
            reader.onload = (_event) => {
              this.imgURL = this.fileName;
            };
          },
          (err) => {
            this.toast.error('Error on file upload');
          }
        );
      }
      // };
      // }
    }
  }
  // onChangeimg END
  // ********************************************************************************************

  addTeanFNCall() {
    // if (!this.fileName) {
    //   return
    // }
    try {
      let data = {
        name: this.addTeamForm.value.addteamName,
        logo: this.imgURL,
        teamSize: this.addTeamForm.value.addteamSize,
      };
      // make sure teamSize is number
      if (data.teamSize) {
        data.teamSize = Number(data.teamSize);
      }
      if (this.imgURL == 'assets/icon/add-team.png') {
        delete data.logo;
      }

      this.csObj.addTeams(data).subscribe(
        (res: any) => {
          if (res.status == 200) {
            this.addTeamForm.reset();
            this.toast.success('Team created successfully.');
            this.sharedCodeVal = res.output.teamData.code;
            this.shareCodeDialogue(res.output.teamData.code);
          } else {
            this.toast.error(res.message);
          }
        },
        (err: any) => {
          this.toast.error(err.error.error.message);
        }
      );
    } catch (e) { }
  }

  shareCodeDialogue(shareCode: any) {
    try {
      const dialogRef = this.dialogue.open(ShareCodeAddTeamsComponent, {
        hasBackdrop: true,
        disableClose: true,
        id: 'sharecode-model',
        width: '469px',
        data: {
          userType: {
            titleOne: 'Share Code to Join',
            text: '',
            imgPath: '',
            sharedCode: shareCode,
          },
        },
      });
    } catch (e) { }
  }

  CloseModal() {
    this.csObj.callTeamList(true);
    // let currentURL = this.router.url
    // this.router.navigateByUrl('/organization_dash', { skipLocationChange: true }).then(() => {
    //   this.router.navigate([currentURL]);
    // });
  }

  UpdateTeanFNCall() {
    try {
      let data = {
        id: this.data.userType.id,
        name: this.addTeamForm.value.addteamName,
        logo: this.imgURL,
        teamSize: this.addTeamForm.value.addteamSize,
      };
      // make sure teamSize is number
      if (data.teamSize) {
        data.teamSize = Number(data.teamSize);
      }
      this.csObj.editTeams(this.data.userType.id, data).subscribe(
        (res: any) => {
          if (res.status == 200) {
            this.addTeamForm.reset();
            let currentURL = this.router.url;

            // this.toast.error(res.message)
            this.toast.success('Team updated successfully');
            // this.sharedCodeVal = res.output.teamData.code;
            // this.shareCodeDialogue(res.output.teamData.code);

            this.csObj.callTeamList(true);

            // this.router.navigateByUrl('/organization_dash', { skipLocationChange: true }).then(() => {
            //   this.router.navigate([currentURL]);
            // });
          } else {
            this.toast.error(res.message);
          }
        },
        (err: any) => {
          this.toast.error(err.error.error.message);
        }
      );
    } catch (e) { }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

  croppedProfilePicture(event: any) {
    console.log('Profile Picture Image Cropped');
    this.croppedProfilePicRef = event;
  }

  openProfilePictureModal(fileChangedEvent: any) {
    this.originalProfilePicRef = fileChangedEvent.base64;
    this.imageChangedEvent = fileChangedEvent;
    this.originalProfilePicName = fileChangedEvent?.target?.files[0]?.name;
    var mimeType = fileChangedEvent?.target?.files[0].type;

    if (mimeType.includes('image/avif') == true) {
      this.toast.error('Only JPEG and PNG is allowed');
      return;
    }

    if (mimeType.match(/image\/*/) == null) {
      this.toast.error('Only images are supported.');
      return;
    }
    // (<HTMLInputElement>document.getElementById('closeBtn')).click();
    this.openModal(this.ProfilePicCropModal);
  }

  profileChanged: any = true;
  uploadProfile() {
    this.modalRef.hide();
    this.spinner.show();
    let file = this.croppedProfilePicRef.base64;
    let fd = new FormData();
    const imageFile = new File(
      [this.csObj.dataURItoBlob(file)],
      this.originalProfilePicName,
      { type: 'image/png' }
    );
    fd.append('image', imageFile);
    this.csObj.uploadImage(fd).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.profileChanged = false;
          this.fileName = res.output.imageUrl1.location;
          this.imgURL = this.fileName;
          this.fileName = res.output.imageUrl1.location;
          this.imgURL = this.fileName;
          // this.openModalAddTeam();
        } else {
          this.toast.error(res.message);
        }
      },
      (err) => {
        this.toast.error(err.error.error.message);
      }
    );
    this.spinner.hide();
  }

  // dataURItoBlob(dataURI: any) {
  //   const parts = dataURI.split(';base64,');
  //   const byteString = atob(parts[1]);
  //   const arrayBuffer = new ArrayBuffer(byteString.length);
  //   const int8Array = new Uint8Array(arrayBuffer);
  //   for (let i = 0; i < byteString.length; i++) {
  //     int8Array[i] = byteString.charCodeAt(i);
  //   }
  //   const blob = new Blob([int8Array], { type: 'image/png' });
  //   return blob;
  // }

  openModalAddTeam() {
    this.dialogue.open(AddteamsModalComponent, {
      hasBackdrop: true,
      id: 'addmore-model',
      disableClose: true,
      data: {
        userType: {
          titleOne: '',
          titleTwo: '',
          text: '',
          imgPath: this.imgURL,
          id: '',
          access: 'add',
          teamName: '',
        },
      },
    });
  }

  onClickFile() {
    (<HTMLInputElement>document.getElementById('files')).value = '';
  }

  openAddPlayerModal() {
    this.dialogue.open(AddPlayerModalComponent, {
      hasBackdrop: true,
      id: 'addmore-model',
      disableClose: true,
      data: {
        userType: {
          titleOne: '',
          titleTwo: '',
          text: '',
          // imgPath: this.imgURL,
          id: this.data?.userType.id,
          access: 'add',
          teamName: '',
          details: this.playersList,
        },
      },
    });
  }

  playerDeleted: any = true;
  deletePlayer(id: any, index: any) {
    this.clubService
      .deleteTeamPlayer({ teamId: this.data?.userType?.id, playerId: id })
      .subscribe((res: any) => {
        if (res.status == 200) {
          this.playerDeleted = false;
          this.playersList.players.splice(index, 1);
          this.toast.success('Player deleted successfully');
        }
      });
  }

  checkResolution(fName: any, lName) {
    let width = window.innerWidth;

    let fullName = fName + ' ' + lName;

    if (width < 500) {
      if (fullName.length > 8) {
        return fullName.slice(0, 8) + '..';
      } else {
        return fullName;
      }
    } else {
      return fullName;
    }
  }
}
